import { IconSelectComponent } from './icon-select/icon-select.component';
import { RoleSelectComponent } from './role-select/role-select.component';

export * from './icon-select/icon-select.component';
export * from './role-select/role-select.component';

export const SELECTORS = [IconSelectComponent, RoleSelectComponent];
